import './FeedSkeleton.css';

/** Placeholder layout for the mix-stream — 1 hero, 3 pairs, 1 promo band. */
export function FeedSkeleton() {
  return (
    <div className="feed-skel-list" aria-hidden>
      <div className="feed-skel-hero feed-skel-shimmer" />
      <div className="feed-skel-pair">
        <div className="feed-skel-tile feed-skel-shimmer" />
        <div className="feed-skel-tile feed-skel-shimmer" />
      </div>
      <div className="feed-skel-pair">
        <div className="feed-skel-tile feed-skel-shimmer" />
        <div className="feed-skel-tile feed-skel-shimmer" />
      </div>
      <div className="feed-skel-promo feed-skel-shimmer" />
      <div className="feed-skel-pair">
        <div className="feed-skel-tile feed-skel-shimmer" />
        <div className="feed-skel-tile feed-skel-shimmer" />
      </div>
    </div>
  );
}
